<template>
    <div>
        <b-modal id="updatePassword" ref="updatePasswordModal" hide-footer @show="getCurrentData">
            <h2 class="text-center mb-50">Passwort ändern</h2>
            <p class="mandatory-note text-center mb-0">*Pflichtfelder bitte ausfüllen</p>
            <form>
                <div class="form-row">
                    <div class="form-group floating-label col-12">
                        <input type="password" class="form-control" ref="pw1" placeholder="Altes Passwort"
                               v-model="oldPassword">
                        <label>Altes Passwort *</label>
                        <i class="passwordIcon" :class="[isActive ? 'hide' : 'show']"
                           @click="showPassword($refs.pw1), isActive = !isActive"></i>
                    </div>
                </div>
                <div class="form-row mb-10">
                    <div class="form-group floating-label col-12">
                        <input type="password" class="form-control" ref="pw2" placeholder="Neues Passwort"
                               v-model="newPassword">
                        <label>Neues Passwort *</label>
                        <i class="passwordIcon" :class="[isActive2 ? 'hide' : 'show']"
                           @click="showPassword($refs.pw2), isActive2 = !isActive2"></i>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12">
                        <p class="small mb-0">Bitte beachte: Das Passwort muss</p>
                        <ul class="password-requirements">
                            <li :class="{active: eightChars}">- mindestens 8 Zeichen lang sein</li>
                            <li :class="{active: largeChar}">- mindestens einen Großbuchstaben enthalten</li>
                            <li :class="{active: smallChar}">- mindestens einen Kleinbuchstaben enthalten</li>
                            <li :class="{active: specialChar}">- mindestens ein Sonderzeichen enthalten</li>
                        </ul>
                    </div>
                </div>
            </form>

            <footer class="modal-footer yes-no">
                <button type="button" class="btn btn-link" @click="hideModal">Abbrechen</button>
                <button type="button" class="btn btn-primary" :disabled="!valid" @click="updatePassword">Änderung
                    speichern
                </button>
            </footer>

        </b-modal>
    </div>
</template>
<script>

    import {apiChangeAddress} from "../utils/api";
    import bcrypt from "bcryptjs";

    export default {
        name: 'profileChangePasswordComponent',
        data() {
            return {
                oldPassword: '',
                newPassword: '',
                isActive: false,
                isActive2: false
            }
        },
        vuelidation: {
            data: {
                oldPassword: {
                    required: true
                },
                newPassword: {
                    required: true
                }
            }
        },
        methods: {
            hideModal() {
                this.$refs.updatePasswordModal.hide();
            },
            updatePassword(e) {

                e.preventDefault();

                let salt = '$2a$10$Y9WDFNqH6NSSjS7e0RcjNe',
                    oldPwd = bcrypt.hashSync(this.oldPassword, salt),
                    newPwd = bcrypt.hashSync(this.newPassword, salt);

                apiChangeAddress({
                    "email": this.$store.state.user.email,
                    "oldPasswordhash": oldPwd,
                    "newPasswordhash": newPwd,
                })
                    .then(response => {

                        if (response.data.code === 0) {

                            this.$toasted.success('Vielen Dank. Dein Passwort wurde geändert.', {
                                duration: 3000,
                                position: 'bottom-right'
                            });

                            this.$store.commit('user', {
                                email: this.$store.state.user.email,
                                password: this.newPassword
                            });

                            this.$nextTick(() => {

                                this.oldPassword = '';
                                this.newPassword = '';

                                this.hideModal();

                            });
                        } else if (response.data.code)
                            this.$toasted.error(response.data.message, {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        else {
                          console.log(response);
                        }


                    })
                    .catch(e => {
                        console.log('ERROR: ', e);
                        this.$store.commit('error', e);
                    });

            },
            showPassword(x) {
                if (x.type === "password")
                    x.type = "text";
                else
                    x.type = "password";
            }
        },
        computed: {
            eightChars: function () {
                return this.newPassword.length > 7;
            },
            largeChar: function () {
                return (/[A-Z]/.test(this.newPassword));
            },
            smallChar: function () {
                return (/[a-z]/.test(this.newPassword));
            },
            specialChar: function () {
                return (/[~`!#$%\^&*@+=\-\[\]\\';,/{}|\\":<>\?]/g.test(this.newPassword));
            },
            valid: function () {
                return this.$vuelidation.valid() && this.eightChars && this.largeChar && this.smallChar && this.specialChar
            }
        }
    }
</script>
